function Erp() {
    return (
      <>
  
{/* Header Start */}
<div className="container-fluid bg-breadcrumb6">
<div className="bg-breadcrumb-single" />
<div className="container text-center py-5" style={{ maxWidth: 900 }}>
  <h4
    className="text-white display-4 mb-4 wow fadeInDown"
    data-wow-delay="0.1s"
  >
    SAP Solutions
  </h4>
 
</div>
</div>

  {/* START PORTFOLIO */}
  <div className="container pageiderp">
  <section className="portfolio section-padding" id="portfolio">
    <div className="row">
      <div className="section-title1  wow zoomIn">
        <div className="indented">
          <section>
            {/* <h2>SAP Implementation</h2> */}
            <p>
              Through Fit-Gap Analysis and business process mappings, our team will handhold you to explore how best to adopt SAP System functionalities in automating your business processes.
              And when it comes to converting design plans into software configurations and coding, our team is second to none in ensuring the realization of a working software in record time.
              As we are a official SAP Gold Partner You can trust us to deploy your SAP System within your time and cost budget.
            </p>
            </section>

             </div>
      </div>
    </div>
  </section>
  </div>

           <div className="container-fluid service py-3">
                <div className="container py-2">
                    <div className="text-center mx-auto pb-3 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: 800 }}>
                        <h2 className="text-primary">SAP Services</h2>
                    </div>
                    <div className="row pb-4 g-3 justify-content-center text-center">
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/saperp.jpeg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/erpsupportmodels" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> ERP Support Models
                                        </a>
                                        {/* <p className="mb-4">
                                            Empower your business with robust, scalable, and secure infrastructure solutions designed to support today’s digital...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/erpsupportmodels">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/sapIntegration.png" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/dataintegration" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> SAP Integration
                                        </a>
                                        {/* <p className="mb-4">
                                            Unlock powerful insights and drive smarter decision-making with our Business Analytics solutions. We specialize ...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/dataintegration">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/sapExtension.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/sapextention" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" />SAP Extension
                                        </a>
                                        {/* <p className="mb-4">
                                            Streamline, innovate, and scale your business operations with our expert SAP services. Our team specializes in both SAP and Oracle...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/sapextention">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/*
            <div className="col-12">
                <a className="btn btn-primary rounded-pill py-3 px-5 wow fadeInUp" data-wow-delay="0.1s" href="/">
                  Services More
                </a>
            </div> */}
                    </div>
                    <div className="row g-3 justify-content-center text-center">
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/dataMigration.jpeg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/datamigration" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> Data Migration
                                        </a>
                                        {/* <p className="mb-4">
                                            In today’s digital landscape, robust cybersecurity is essential for safeguarding sensitive data and ensuring business...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/datamigration">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/trainingsmall.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/endusertraining" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> End User Training
                                        </a>
                                        {/* <p className="mb-4">
                                            Microservices architecture is transforming how applications are built, scaled, and managed. By breaking down...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/endusertraining">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/changeManagmentsmall.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/changemanagement" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> Change Management
                                        </a>
                                        {/* <p className="mb-4">
                                            
                                            Our IT recruitment services connect you with top talent, handpicked to drive your business forward. In today’s...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/changemanagement">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/valueRealizationsmall.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/valuerealization" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> SAP Value Realization
                                        </a>
                                        {/* <p className="mb-4">
                                            
                                            Our IT recruitment services connect you with top talent, handpicked to drive your business forward. In today’s...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/valuerealization">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/itSecurity2.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/sapsecurityaudit" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> SAP Security Audit
                                        </a>
                                        {/* <p className="mb-4">
                                            
                                            Our IT recruitment services connect you with top talent, handpicked to drive your business forward. In today’s...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/sapsecurityaudit">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                          <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/processEngineering.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/reengineer" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> SAP Process<br /> Re-engineering
                                        </a>
                                        {/* <p className="mb-4">
                                            
                                            Our IT recruitment services connect you with top talent, handpicked to drive your business forward. In today’s...
                                        </p> */}
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/reengineer">
                                            Explore More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>


          
           
            
            
          



          
       

   {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  <div className="container-fluid copyright py-3">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-md-6 text-center text-md-start mb-md-0">
                <span className="text-body">
                  <i className="fas fa-copyright text-light me-1" />
                  2024 Celersoft. All rights reserved.
                </span>
              </div>
              {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
            </div>
          </div>
        </div>
  {/* <a href="/Erp" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

<button
  className="btn btn-primary btn-lg-square back-to-top"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
>
  <i className="fa fa-arrow-up" />
</button>

        </>
    );
};

export default Erp